<div class="container" [style.border-left-color]="leftStatusColor">
  <div class="content">
    {{ testData?.tagNumber }}
  </div>

  <app-status-circle [status]="testData?.mcStatus?.name" [useSmall]="true" />
</div>
